var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('meta',{attrs:{"name":"apple-itunes-app","content":"app-id=1537308329, app-clip-bundle-id=com.fonzmusic.Clip"}}),_c('c-splash'),_c('c-clients'),_c('c-how-fonz-works'),_c('c-the-benefits'),_c('c-map'),_c('c-download-app')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }